<template>
  <div class="d-flex justify-center actions-bar">
    <NewPublishingScheduleDialog @close="closeDialog" :isOpen="isOpen" />
    <SecondaryButton
      @click.native="openDialog"
      permission="create"
      color="primary"
    >
      <div class="d-flex align-center justify-center mb-1">
        <v-img contain src="@/assets/svg/publishing-schedule-icon-white.svg" />
        <v-icon small>mdi-plus</v-icon>
      </div>
      New Publishing Schedule
    </SecondaryButton>
  </div>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import NewPublishingScheduleDialog from "@/views/settings/components/publishing-schedule-templates/components/dialogs/PublishingScheduleDialog";

export default {
  components: {
    SecondaryButton,
    NewPublishingScheduleDialog
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss"></style>
